import type { FaireProductEntity } from "../../entity_types/product";

export const p_u7p6z38whn: FaireProductEntity = {
  token: "p_u7p6z38whn",
  type: "product",
  name: "Butter Ornament",
  brandToken: "b_48a2b17b",
  brandName: "Silk Road Bazaar",
  imageUrl:
    "https://cdn.faire.com/fastly/d0bc6da5e94def788640fd99ea5d6e80ce3ac1abde6ff38f1d3e16d09779c696.jpeg",
  galleryImageUrls: [],
  priceDollars: 8,
  description:
    "This felt ornament is beautifully crafted with intricate details. This handmade ornament is great for year-round decor! We work with women artisans in Kyrgyzstan to handcraft products using natural fibers and eco-friendly resources. All details are hand stitched and embroidered.\n\nOur talented artisans work in the remote regions of Kyrgyzstan. We connect with artists who are far from the capitals, have limited market access and have carried on traditional craft culture.\n\n• *Approximately 4-5 inches in length*",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:18.015Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
